/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */

import store from '@/store';
import productService from '@/services/product';
import Vue from 'vue';

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
  },
  mounted() {
    this.fetchProducts();
  },
  data() {
    return {
      selectedGroup: {},
      pageSize: 10,
      selectedPage: 1,
      selectedProduct: {},
      deleteDialog: false,
      action: `${process.env.API_LOCATION}api/products/upload_excel`,
    };
  },
  computed: {
    products() {
      return store.state.product.products;
    },
    count() {
      return store.state.product.count;
    },
  },
  methods: {
    fetchPage() {
      this.fetchProducts();
    },
    async fetchProducts() {
      store.dispatch('product/getProducts', {
        filter: {
          limit: this.pageSize,
          skip: (this.selectedPage - 1) * this.pageSize
        },
      });
    },
    handlePageChange(page) {
      this.selectedPage = page;
      this.fetchPage();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchPage();
    },
    confirmDelete(product) {
      this.selectedProduct = product;
      this.deleteDialog = true;
      this.fetchPage();
    },
    async deleteSelectedProduct() {
      this.deleteDialog = false;
      try {
        await productService.del(this.selectedProduct);
        this.fetchPage();
      } catch (e) {
        console.error(e);
      }
    },
    updateStatus(product, newProduct) {
      product.status = newProduct.status;
    },
    navigate(data) {
      Vue.router.push(data);
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    uploadSuccess() {
      this.fetchProducts();
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/product/view/index.js